<template>
<div class="form-step-item step-2">
    <div class="panel">
        <h3>Select Formulation Base</h3>
        <h5 class="label">Choose a base:</h5>
        <div class="accordion-section">
            <div class="accordion-header" @click.prevent="onClickAccordion('triple-chamber')">
                <span>{{basesGroups.triple_chamber.label}}</span>
                <i class="accordion-icon" v-bind:class="[openTripleChamberSection === true ? 'icon-chevron-up' : 'icon-chevron-down']"></i>
            </div>
            <div class="accordion-body"  v-if="openTripleChamberSection === true">
                <div class="formulation-table">
                    <table>
                        <tr>
                            <th class="text-left">Formulation</th>
                            <th>Volume (mL)</th>
                            <th>Nitrogen (g)</th>
                            <th>Glucose (kCal)</th>
                            <th>Lipid (kCal)</th>
                            <th>Total Calories (kCal)</th>
                            <th>Electrolytes</th>
                        </tr>
                        <tr v-for="(item, index) in basesGroups.triple_chamber.items" :key="index">
                            <td class="text-left basis-radio">
                                <div class="bax-boxed-radio">
                                    <div class="bax-radio">
                                        <input type="radio" v-bind:id="'base_' + item" class="css-checkbox" v-bind:value="item" v-model="formData.base" @change="onSelectBase('default')" />
                                        <label v-bind:for="'base_' + item" class="css-label">{{basesItems[item].label}}</label>
                                    </div>
                                </div>
                            </td>
                            <td>{{basesItems[item].bag_volume}}</td>
                            <td>{{basesItems[item].default_list_data.nitrogen}}</td>
                            <td>{{basesItems[item].default_list_data.glucose_kcal}}</td>
                            <td>{{basesItems[item].default_list_data.lipid_kcal}}</td>
                            <td>{{basesItems[item].total_calories}}</td>
                            <td>{{basesItems[item].default_list_data.electrolytes ? 'Yes' : 'No'}}</td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
        <div class="accordion-section">
            <div class="accordion-header" @click.prevent="onClickAccordion('custom')">
                <span>{{basesGroups.custom.label}}</span>
                <i class="accordion-icon" v-bind:class="[openCustomSection === true ? 'icon-chevron-up' : 'icon-chevron-down']"></i>
            </div>
            <div class="accordion-body"  v-if="openCustomSection === true">
                <div class="formulation-table">
                    <table>
                        <tr>
                            <th class="text-left">Formulation</th>
                        </tr>
                        <tr v-for="(item, index) in basesGroups.custom.items" :key="index">
                            <td class="text-left basis-radio">
                                <div class="bax-boxed-radio">
                                    <div class="bax-radio">
                                        <input type="radio" v-bind:id="'base_' + item" class="css-checkbox" v-bind:value="item" v-model="formData.base" @change="onSelectBase('default')" />
                                        <label v-bind:for="'base_' + item" class="css-label">{{basesItems[item].label}}</label>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
                <p class="other-formulation">To create a custom bag with another base, please <router-link :to="{ name: 'TPNCustomFormulationContact' }">tell us more details</router-link>.</p>
            </div>
        </div>
    </div>
    <div class="panel">
        <h5 class="label">Or, choose a recent formulation as base:</h5>
        <div class="accordion-section">
            <div class="accordion-header" @click.prevent="onClickAccordion('recent')">
                <span>Recent Formulations</span>
                <i class="accordion-icon" v-bind:class="[openRecentSection === true ? 'icon-chevron-up' : 'icon-chevron-down']"></i>
            </div>
            <div class="accordion-body recent"  v-if="openRecentSection === true">
                <div class="formulation-form-row search-recent">
                    <div class="col-4">
                        <input type="text" class="form-control" v-model="searchRecentText">
                    </div>
                    <div class="col-2">
                        <button type="button" class="bax-btn bax-btn-bordered-blue-brand" :class="{ 'loading': searchingRecent }" @click.prevent="onFilterRecent">Search</button>
                    </div>
                    <div class="col-6 d-flex align-items-center justify-content-end">
                        <p>Can't find what you want? <router-link :to="{ name: 'TPNCustomFormulation' }" >View all Custom Formulations</router-link></p>
                    </div>
                </div>
                <div class="formulation-table basis-list" v-if="recentList.length">
                    <table>
                        <tr>
                            <th  class="text-center">Select</th>
                            <th>Your Description</th>
                            <th>Patient</th>
                            <th>Stability</th>
                            <th>Latest activity</th>
                            <th>Status</th>
                            <th></th>
                        </tr>
                        <tr v-for="(item, index) in recentList" :key="index">
                            <td class="basis-radio">
                                <div class="bax-boxed-radio justify-content-center">
                                    <div class="bax-radio">
                                        <input type="radio" v-bind:id="'base_' + index" class="css-checkbox" v-bind:value="item.id" v-model="formData.base" @change="onSelectBase('custom')" />
                                        <label v-bind:for="'base_' + index" class="css-label"></label>
                                    </div>
                                </div>
                            </td>
                            <td>{{ item.description }}</td>
                            <td>{{ item.patient }}</td>
                            <td class="stability" :class="item.stability">{{ item.stability }}</td>
                            <td>
                                {{item.status === 'submitted' ? 'Submitted by:' : 'Last modified by:'}}
                                <br>
                                {{item.lastActivityUser}}, {{item.lastActivityDate}} {{item.lastActivityTime}}
                            </td>
                            <td class="status">{{ item.status }}</td>
                            <td class="text-center"><button type="button" class="bax-btn bax-btn-blue-brand" @click.prevent="onModalOpen(item.id)">View</button></td>
                        </tr>
                    </table>
                    <span class="form-error" v-if="loadingBaseError">Sorry, there was an error loading the selected formulation</span>
                </div>
                <p v-else class="no-recent">
                    There are no recent formulation
                    <span v-if="searchRecentText"> for the specified text search</span>
                </p>
            </div>
        </div>
    </div>
    <span class="form-error" v-if="$v.formData.base.$dirty && !$v.formData.base.required">Please select a base</span>
    <div class="navigation-container">
        <button type="button" class="bax-btn bax-btn-blue-brand" @click.prevent="onFormNext">Create formulation</button>
    </div>
    <PreviewFormulationModal class="preview-formulation-modal" :formData="modalData" :baseInfo="modalBaseInfo" :settings="formulationsData.settings" :open="modalPreview" @modal_close="onModalClose" />
</div>
</template>
<script>

import { required } from 'vuelidate/lib/validators';
import CustomFormulationService from '@/core/api/tpn/customFormulation.service';
import PreviewFormulationModal from '@/views/Tpn/CustomFormulationCreate/PreviewFormulationModal.vue';

export default {
    name: 'FormStep2',
    components: {
        PreviewFormulationModal,
    },
    props: {
        formData: {
            required: true,
        },
        formulationsData: {
            required: true,
        },
        basisList: {
            required: true,
        },
    },
    data() {
        return {
            recentList: this.basisList,
            searchRecentText: '',
            searchingRecent: false,
            openTripleChamberSection: false,
            openCustomSection: false,
            openRecentSection: false,
            basesGroups: this.formulationsData.settings.groups,
            basesItems: this.formulationsData.bases,
            selectedBaseType: '',
            modalPreview: false,
            modalData: false,
            modalBaseInfo: false,
            loadingBaseError: false,
        };
    },
    validations: {
        formData: {
            base: {
                required,
            },
        },
    },
    computed: {
    },
    methods: {
        onClickAccordion(type) {
            switch (type) {
                case 'triple-chamber':
                    this.openTripleChamberSection = !this.openTripleChamberSection;
                    break;
                case 'custom':
                    this.openCustomSection = !this.openCustomSection;
                    break;
                case 'recent':
                    this.openRecentSection = !this.openRecentSection;
                    break;
                default:
                    break;
            }
        },
        onFormNext() {
            this.$v.$touch();
            this.loadingBaseError = false;
            if (this.selectedBaseType === 'custom') {
                const selectedItem = this.recentList.find((item) => item.id === this.formData.base);
                if (selectedItem) {
                    this.$emit('set_preloaded_data', selectedItem.formData);
                    this.$emit('validation_response', !this.$v.$invalid);
                } else {
                    this.loadingBaseError = true;
                    this.$emit('validation_response', false);
                }
            } else {
                this.$emit('validation_response', !this.$v.$invalid);
            }
        },
        onSelectBase(type) {
            this.selectedBaseType = type;
        },
        onModalOpen(id) {
            const selectedItem = this.recentList.find((item) => item.id === id);
            if (selectedItem) {
                this.modalPreview = true;
                this.modalData = selectedItem.formData;
                this.modalBaseInfo = this.formulationsData.bases[selectedItem.formData.base];
            } else {
                // error
            }
        },
        onModalClose() {
            this.modalPreview = false;
            this.modalData = false;
            this.modalBaseInfo = false;
        },
        onFilterRecent() {
            if (this.searchingRecent) {
                return;
            }
            this.searchingRecent = true;
            CustomFormulationService.getCustomFormulationRecent(this.searchRecentText)
            .then((res) => {
                this.searchingRecent = false;
                const { data } = res;
                this.recentList = data.list;
            });
        },
    },
};
</script>
